<template>
  <!-- 选择审批人（多选） -->
  <a-transfer
    :data-source="dataSource"
    :list-style="{ width: '45%', height: '300px' }"
    :titles="['审批人', '已选择']"
    show-search
    :render="item => `${item.title} - ${item.description}`"
    @change="handleChange"
    @selectChange="handleSelectChange"
    :selected-keys="selectedKeys"
    :target-keys="targetKeys"
  ></a-transfer>
</template>

<script>
export default {
  name: 'MultiSelectApproval',
  data() {
    return {
      targetKeys: [],
      selectedKeys: [],
    }
  },
  props: ['list'],
  computed: {
    dataSource() {
      return this.list.map((item, index) => {
        return {
          key: `${item.roleId}_${item.username}_${index}`,
          title: `${item.name}(${item.username})`,
          description: item.roleName,
        }
      })
    },
  },
  methods: {
    handleChange(targetKeys) {
      this.targetKeys = targetKeys
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      const targetKeys = [...this.targetKeys, ...sourceSelectedKeys]
      this.targetKeys = targetKeys
      if (targetSelectedKeys && targetSelectedKeys.length == 1) {
        const crtKey = targetSelectedKeys[0]
        const crtIndex = targetKeys.findIndex(key => key == crtKey)
        this.targetKeys.splice(crtIndex, 1)
      }
    },
    validate(showWarning = true) {
      const targetKeys = this.targetKeys
      if (targetKeys.length === 0) {
        showWarning &&
          this.$notification.warning({
            message: '提示',
            description: '请选择审批人',
          })
        return false
      }
      const approvePersons = targetKeys.map(key => {
        const info = key.split('_')
        return {
          roleId: info[0],
          username: info[1],
        }
      })
      return { approvePersons }
    },
  },
}
</script>

<style></style>
